import { getPreviousQuarter } from "../../utils/dateUtils";

export const MY_SUBMISSIONS_CONSTANTS = {
  BREADCRUMB: {
    TITLE: "My Submissions",
    PATH: "/my-submissions",
  },
  DEFAULT_USER: {
    USERNAME: "",
  },
  QUERY_PARAMS: {
    DEFAULT_YEAR: getPreviousQuarter().year.toString(),
    DEFAULT_QUARTER: getPreviousQuarter().quarter.toString(),
  },
  STATES: {
    LOADING: {
      MESSAGE: "Loading submissions...",
    },
    ERROR: {
      MESSAGE: "Error loading submissions: ",
    },
    EMPTY: {
      TITLE: "No submissions found",
      SUBTITLE: "You haven't submitted any bonus applications in this period.",
      ICON: {
        SIZE: "w-12 h-12",
        COLOR: "text-gray-400",
      },
    },
  },
  LAYOUT: {
    MAX_WIDTH: "max-w-9xl",
    PADDING: "px-4 sm:px-6 lg:px-8",
    SPACING: {
      CONTENT: "space-y-4",
    },
  },
  HEADER: {
    COUNTER_TEXT: "submissions",
  },
};
